import React from 'react';
import { GridToolbarContainer, GridToolbarExport, GridToolbarDensitySelector, GridToolbarFilterButton } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';

const  CustomToolBar = (props) => {
  const { additionalTitle } = props;

  return (
    <GridToolbarContainer className='d-flex justify-content-between'>
      {additionalTitle && (
        <Typography component="div" sx={{ flexGrow: 1 }} fontSize={16} fontWeight='bold'>
          {additionalTitle}
        </Typography>
      )}
      <div className='hide-to-print'>
         <GridToolbarFilterButton />
         <GridToolbarDensitySelector />
         <GridToolbarExport />
      </div>
    </GridToolbarContainer>
  );
}

export default CustomToolBar;